import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import "./subjectlayout.css"
import Swal from 'sweetalert2';
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../../Helpers/apiConfig";

export const UserSubjectLayout = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation()
    const [subjects, setSubjects] = useState([]);
    const [activeCourse, setactiveCourse] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showScrollTop, setShowScrollTop] = useState(false);
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };



    const handleClick = event => {
        if (event.target.id <= activeCourse.sortId) {
            navigate("/user/course/question/" + params.id + "/" + event.target.id + "/1");
        }
        else {
            Swal.fire({
                title: "Hata",
                text: "Önce aktif konunu bitirmelisin.",
                icon: "error",
            });
        }
        //navigate("/user/course/question/" + event.target.id + "/1");
    };
    // const handleReport = event => {
    //     alert("rapor sayfası düzenlenmektedir.")
    // };


    useEffect(() => {
        const fetchdata = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = `${API_BASE_URL}/user/Content/GetSubject`;
                //let url = "https://localhost:7004/api/user/Content/GetSubject";
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss,
                    params: { courseId: params.id },

                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            const subjectsData = res.data['data']['subjects'] || [];
                            setSubjects(subjectsData);
                            const active = res.data['data']['subject'];
                            if (!active) {
                                setactiveCourse(subjectsData[0] || {});
                            } else {
                                setactiveCourse(active);
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err?.message || "Bir hata oluştu");
            }
            setLoading(false);
        }
        fetchdata();
        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);
    const sortedCourses = [...subjects].sort((a, b) => {
        if (a.id === activeCourse.id) return -1;
        if (b.id === activeCourse.id) return 1;
        return 0;
    });

    const normalizeTr = (str) => (str || "").toLocaleLowerCase('tr-TR');

    const filteredCourses = sortedCourses.filter((dt) => {
        const term = normalizeTr(searchTerm.trim());
        return normalizeTr(dt.subjectName).includes(term) || normalizeTr(dt.subjectDesc).includes(term);
    });

    return (
        <div >
            <div className="row">
                <h4>{msg}</h4>
                <br />
                {!loading && (
                    <div>
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control shadow-sm"
                                placeholder="Konu ara..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                        {filteredCourses.length === 0 && (
                            <div className="text-center text-muted py-4">Aramanızla eşleşen konu bulunamadı.</div>
                        )}

                        {filteredCourses && filteredCourses.map((dt) => {
                            if (dt.id === activeCourse.id) {

                                return (
                                    <div style={{ marginTop: "1%", backgroundColor: "Cornsilk" }} class="card card-primary card-outline" key={dt.id}>
                                        <div class="row">
                                            <div class="col-md-9 d-flex flex-column justify-content-center text-left">
                                                <div class="card-body" >
                                                    <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title">Aktif Konu : ' + dt.subjectName + '</h5>' }}></div>
                                                    <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title"> ' + dt.subjectDesc + '</h5>' }}></div>

                                                    <hr />

                                                    <a onClick={handleClick} id={dt.sortId} class="btn btn-primary modern-btn">
                                                        Soruları Gör
                                                    </a>

                                                    {/* <a onClick={handleReport} id={dt.id} class="btn btn-info modern-btn ms-2">
                                                        Raporu Gör
                                                    </a> */}

                                                </div>
                                            </div>
                                            <div class="col-md-3 d-flex justify-content-center align-items-center" >
                                                <img style={{ maxHeight: "100px" }} src={dt.featuredImage} class="img-fluid rounded-start"
                                                    alt="..." />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div style={{ marginTop: "1%", backgroundColor: "Gainsboro" }} class="card card-primary card-outline" key={dt.id}>
                                        <div class="row">
                                            <div class="col-md-9 d-flex flex-column justify-content-center text-left">
                                                <div class="card-body">
                                                    <div dangerouslySetInnerHTML={{ __html: '<p class="card-title"><b>' + dt.subjectName + '</b></p>' }}></div>
                                                    <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title"> ' + dt.subjectDesc + '</h5>' }}></div>

                                                    <hr />

                                                    <a onClick={handleClick} id={dt.sortId} class="btn btn-primary modern-btn">
                                                        Soruları Gör
                                                    </a>

                                                    {/* <a onClick={handleReport} id={dt.id} class="btn btn-info modern-btn ms-2">
                                                        Raporu Gör
                                                    </a> */}

                                                </div>
                                            </div>
                                            <div class="col-md-3 d-flex justify-content-center align-items-center" >
                                                <img style={{ maxHeight: "100px" }} src={dt.featuredImage} class="img-fluid rounded-start"
                                                    alt="..." />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                )}


            </div>
            {showScrollTop && (
                <button
                    onClick={scrollToTop}
                    className="btn btn-primary shadow"
                    style={{
                        position: 'fixed',
                        bottom: '40px',
                        right: '40px',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}
                    title="Yukarı Çık"
                >
                    <i className="pi pi-arrow-up" style={{ fontSize: '1.2rem' }}></i>
                </button>
            )}
        </div>

    );
}
export default UserSubjectLayout;



